import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import ProductActions from '../Redux/ProductRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getProduct (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getProduct, token, action.data)
      if (!res.ok) {
        yield put(ProductActions.productFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(ProductActions.productSuccess(DATA_WITH_PAGE))
        } else {
          yield put(ProductActions.productFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(ProductActions.productFailure())
  }
}

export function * getProductCustom (api, action) {
  yield baseFetchToken(
    api.getProductCustom,
    action.data,
    getToken,
    ProductActions.getProductCustomSuccess,
    ProductActions.getProductCustomFailure
  )
}

export function * createProduct (api, action) {
  yield baseFetchToken(api.createProduct,
    action.data,
    getToken,
    ProductActions.productCreateSuccess,
    ProductActions.productCreateFailure)
}

export function * deleteProduct (api, action) {
  yield baseFetchToken(api.deleteProduct,
    action.data,
    getToken,
    ProductActions.productDeleteSuccess,
    ProductActions.productDeleteFailure)
}

export function * updateProduct (api, action) {
  yield baseFetchToken(api.updateProduct,
    action.data,
    getToken,
    ProductActions.productUpdateSuccess,
    ProductActions.productUpdateFailure)
}

export function * getProductCountry (api, action) {
  yield baseFetchToken(
    api.getProductCountry,
    action.data,
    getToken,
    ProductActions.getProductCountrySuccess,
    ProductActions.getProductCountryFailure
  )
}

export function * postProductCountry (api, action) {
  yield baseFetchToken(
    api.postProductCountry,
    action.data,
    getToken,
    ProductActions.postProductCountrySuccess,
    ProductActions.postProductCountryFailure
  )
}

export function * deleteProductCountry (api, action) {
  yield baseFetchToken(
    api.deleteProductCountry,
    action.data,
    getToken,
    ProductActions.deleteProductCountrySuccess,
    ProductActions.deleteProductCountryFailure
  )
}

export function * getProductCampaign (api, action) {
  yield baseFetchToken(
    api.getProductCampaign,
    action.data,
    getToken,
    ProductActions.getProductCampaignSuccess,
    ProductActions.getProductCampaignFailure
  )
}

export function * postProductCampaign (api, action) {
  yield baseFetchToken(
    api.postProductCampaign,
    action.data,
    getToken,
    ProductActions.postProductCampaignSuccess,
    ProductActions.postProductCampaignFailure
  )
}

export function * putProductCampaign (api, action) {
  yield baseFetchToken(
    api.putProductCampaign,
    action.data,
    getToken,
    ProductActions.putProductCampaignSuccess,
    ProductActions.putProductCampaignFailure
  )
}

export function * deleteProductCampaign (api, action) {
  yield baseFetchToken(
    api.deleteProductCampaign,
    action.data,
    getToken,
    ProductActions.deleteProductCampaignSuccess,
    ProductActions.deleteProductCampaignFailure
  )
}

export function * getProductVariant (api, action) {
  yield baseFetchToken(
    api.getProductVariant,
    action.data,
    getToken,
    ProductActions.getProductVariantSuccess,
    ProductActions.getProductVariantFailure
  )
}

export function * postProductVariant (api, action) {
  yield baseFetchToken(
    api.postProductVariant,
    action.data,
    getToken,
    ProductActions.postProductVariantSuccess,
    ProductActions.postProductVariantFailure
  )
}

export function * putProductVariant (api, action) {
  yield baseFetchToken(
    api.putProductVariant,
    action.data,
    getToken,
    ProductActions.putProductVariantSuccess,
    ProductActions.putProductVariantFailure
  )
}

export function * deleteProductVariant (api, action) {
  yield baseFetchToken(
    api.deleteProductVariant,
    action.data,
    getToken,
    ProductActions.deleteProductVariantSuccess,
    ProductActions.deleteProductVariantFailure
  )
}

export function * getProductVariantItem (api, action) {
  yield baseFetchToken(
    api.getProductVariantItem,
    action.data,
    getToken,
    ProductActions.getProductVariantItemSuccess,
    ProductActions.getProductVariantItemFailure
  )
}

export function * postProductVariantItem (api, action) {
  yield baseFetchToken(
    api.postProductVariantItem,
    action.data,
    getToken,
    ProductActions.postProductVariantItemSuccess,
    ProductActions.postProductVariantItemFailure
  )
}

export function * deleteProductVariantItem (api, action) {
  yield baseFetchToken(
    api.deleteProductVariantItem,
    action.data,
    getToken,
    ProductActions.deleteProductVariantItemSuccess,
    ProductActions.deleteProductVariantItemFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/ProductSagas.js